<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <estado-deuda-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import EstadoDeudaShowData from "./EstadoDeudaShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "EstadoDeudaShow",
        components: {CrudShow, EstadoDeudaShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'cobrox.estadoDeuda.showing',
            }
        },
    }
</script>

